// extracted by mini-css-extract-plugin
module.exports = {"bill":"_2asbob"};